/**
 * Centralized pdfjs-dist worker configuration.
 *
 * Import this module as a side-effect wherever pdfjs-dist is used:
 *   import "@/lib/pdfWorkerSetup";
 *
 * This ensures the worker is configured exactly once, regardless of which
 * component loads first.
 */
import { GlobalWorkerOptions } from "pdfjs-dist";

GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).href;
